import router from './router/index'
import store from './store'
import { getStore } from './config/mUtils'

export function hasAuth(code) {
  if (!code) {
    return true
  } else {
    let userInfo = getStore('userInfo')
    if (!userInfo) {
      return false
    }
    return userInfo.is_super_admin || userInfo.auth_codes.includes(code)
  }
}

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  let userInfo = getStore('userInfo')
  if (to.meta.auth_id) {
    if (!hasAuth(to.meta.auth_id)) {
      alert('权限不足')
      next({ path: '/dashboard' })
    }
  }

  if (to.meta.title == '404') {
    store.commit('LOGOUT')
    next({ path: '/login' })
    return
  }

  // if (to.meta.title) {
  //   document.title = to.meta.title
  // }
  if (whiteList.indexOf(to.path) !== -1) {
    if (to.path == '/login' && userInfo) {
      next({ path: '/dashboard' })
    } else {
      next()
    }
    return
  } else {
    if (!userInfo) {
      next({ path: '/login' })
      return
    }
  }

  store.commit('RECORD_USERINFO', userInfo)
  next()
})